import { FC } from 'react'
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'
import { useFormik } from 'formik'
import { gql, useMutation } from '@apollo/client'
import { useParams } from 'react-router-dom'

type Props = {
  isOpen: boolean
  onClose: () => void
  refetchData: () => Promise<void>
}

const ADD_BUILDPACK_MUTATION = gql`
  mutation AddBuildpackMutation($appName: String!, $source: String!) {
    addBuildPack(appName: $appName, source: $source) {
      id
    }
  }
`

const AddBuildpackModal: FC<Props> = ({ isOpen, onClose, refetchData }) => {
  const { name: appName } = useParams()
  const [addBuildpack, { loading }] = useMutation(ADD_BUILDPACK_MUTATION)

  const initialValues = {
    source: '',
  }
  const formik = useFormik({
    initialValues,
    validate: (values) => {
      const errors: Record<string, string> = {}
      if (!values.source) {
        errors.source = 'Required'
      }
      return errors
    },
    onSubmit: async (values) => {
      const variables = {
        appName,
        source: values.source,
      }
      await addBuildpack({ variables })
      await refetchData()
      formik.resetForm()
      onClose()
    },
  })

  const isControlInvalid = (controlName: keyof typeof initialValues) =>
    !!(formik.errors[controlName] && formik.touched[controlName])

  return (
    <Modal
      isOpen={isOpen}
      size="2xl"
      isCentered
      onClose={() => {
        formik.resetForm()
        onClose()
      }}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Buildpack</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <form onSubmit={formik.handleSubmit}>
            <FormControl
              id="source"
              colorScheme="cyan"
              isRequired
              isInvalid={isControlInvalid('source')}
            >
              <FormLabel htmlFor="source">Buildpack</FormLabel>
              <Input
                type="text"
                id="source"
                name="source"
                onChange={formik.handleChange}
                value={formik.values.source}
                placeholder="e.g.: https://github.com/heroku/heroku-buildpack-nodejs"
              />
              <FormErrorMessage>{formik.errors.source}</FormErrorMessage>
            </FormControl>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="cyan"
            variant="ghost"
            mr={3}
            onClick={() => {
              formik.resetForm()
              onClose()
            }}
          >
            Cancel
          </Button>
          <Button
            colorScheme="cyan"
            color="white"
            onClick={() => formik.handleSubmit()}
            isLoading={formik.isSubmitting || loading}
          >
            Add Buildpack
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default AddBuildpackModal
